import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  gs,
  ls,
  useCfmz,
  useLdrz,
//  BarC,
  BoxC,
  BtnC,
  IptC,
  LblC,
  LgnIdC,
  LinkC,
  RootC,
  GridC,
  TextC,
  cmLSG,
  _cv_31___Mz,
  useGblz,
} from 'lib';
*/
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as LinkC from "./_cccLinkC";
import * as LgnIdC from "./_ccmLgnIdC";
import * as RootC from "./_ccmRootC";
import * as cmLSG from "./_cmLSG";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useCfmz } from "./_csMdlCfm";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

import IccvFtr from './IccvFtr';

import * as icvI18___Mz from './icvI18___Mz';

import * as icm from './icm';
import * as ihv from './ihv';

let $cky = true;
let $idz = {
  id: '',
  pwd: ''
};

export const N = () => {

  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();

  const _sCfmz = useCfmz();
  const _sLdrz = useLdrz();

  const _sPz = ls.usePagez({
    steps: [0],
  });

  const _udtThis = ls.udtThis();

  React.useEffect(() => {
    cmLSG.chkAsync()
    .then((_b: ht.b) => {
      $cky = _b;
      icm.setLgnAsync({
        frcUdt: _udtThis,
      })
    });
  }, []);

  let _bLgn = false;
  if (
    _gStgz.crt.S03031213 == '1' &&
    (
      hfDTM.getNow() < _gStgz.crt.S03031313 ||
      hfDTM.getNow() > _gStgz.crt.S03031323
    )
  ) _bLgn = true;

  //hf.l(`icvLgnD20Rz 78: ${_gStgz.crt.S01050111}`);

  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        boxStlz: a(`f/n`),
        oClds: [

          cr.c(GridC.N, {
            key: -20,
            abtType: 'lgnCmnz',
            boxStlz: 
              cr.chkDvc() == 'p' ?
                undefined
              : a('f/n fd/csc'),
            lineCs: [
              {
                boxStlz: a('dw/f sc/bl7'),
                cellCs: [
                ]
              },
              {
                boxStlz: a('dw/f dh/10 f/n mb/4 sc/bl7'),
                cellCs: [
                  {
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'lgnHdgDntz',
                        textz: {
                          pfx: `【${_gUserz.crt._20rz?._pfx ?? ''}】 施設利用予約`,
                          stlz: a('ta/c tc/lt1'),
                        },
                      }),
                    ]
                  }
                ]
              },
              {
                boxStlz: a('dw/f dwx/100 f/n mb/4 ph/2'),
                cellCs: [                
                  {
                   boxStlz: a('bc/lt3 br/1 bw/2 dw/f fd/ccc p/2'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        textz: {
                          pfx: _gStgz.crt.S03031111
                        },
                      }),

                    ]
                  }
                ]
              },
              _bLgn ?
              {
                boxStlz: a('f/n mb/4 ph/2'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(TextC.N, {
                        key: -10,
                        textz: {
                          pfx: '▼ 登録したログインIDとパスワードを入力し、[ログイン] ボタンを押してください。',
                        },
                      }),

                    ]
                  }
                ]
              }
              : null,
              _bLgn ?
              {
                boxStlz: a('f/n mb/4'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(LgnIdC.N, {
                        key: -10,
                        cz: {
                          idz: $idz,
                          ccd: 'bl7',
                          grtCfmz: () => ({
                            cdn: `_10rt1100i = 10` 
                          }),
                          atrCfm: async (_dz: ht.dz) => {
                            const __31z = await _cv_31___Mz.load_31rDzAsync({
                              _31r_fst: _dz._10r_31r1f,
                            });
                            await _gUserz.saveAsync({
                              _31rz: __31z._31rz,
                            })
                            const _i18r_fst = Number(String(_dz._icn).split('_')[0]);                              
                            const _i18z = await icvI18___Mz.loadI18rDzAsync({
                              i18r_fst: _i18r_fst,
                            });
                            await _gUserz.saveAsync({
                              i18rz: _i18z.i18rz,
                              i15rz: _i18z.i15rz,
                            })
                            await _gUserz.saveAsync({
                              usrClr: 'bl',
                            });
                            cr.moveTo({
                              pageName: 'icvHomeD10Rz',
                            })
                          },
                        },
                      })

                    ]
                  }
                ]
              }
              : null,
              _bLgn ?
              {
                boxStlz: a('f/n ph/2'),
                cellCs: [
                  {
                    oClds: [

                      $cky == false ?
                      cr.c(TextC.N, {
                        key: -10,
                        textz: {
                          pfx: '※ ブラウザのクッキーを有効にしてください。',
                          stlz: a('tc/rd6 ts/s'),
                        },
                      })
                      : null,

                      cr.c(LinkC.N, {
                        key: -20,
                        boxStlz: a(`fd/rsc fw`),
                        cz: {
                          onPrs: async () => {
                            _sLdrz.show();
                            let _i18z = {} as ht.dz;
                            const _b = await hf.ectSrlAsync([
                              async () => {
                                let _b2 = true;
                                if (!hf.f($idz.id)) _b2 = false;
                                if (!_b2) {
                                  _sCfmz.show({
                                    pfx: 'ログインIDを設定ください。',
                                    ls: [{ key: 1, pfx: 'はい'}],
                                  });                                  
                                }
                                return _b2;
                              },
                              async () => {
                                let _b2 = true;
                                _i18z = await icvI18___Mz.loadI18rDzAsync({
                                  id: $idz.id
                                })
                                if (
                                  !hf.f(_i18z?.i18rz?.i18ra4110s) &&
                                  !hf.f(_i18z?.i18rz?.i18ra4210s) &&
                                  !hf.f(_i18z?.i18rz?.i18ra4310s)
                                ) _b2 = false;
                                if (!_b2 ) { // メールアドレスを確認できなかった場合
                                  await hf.waitAsync(5000)
                                  .then(() => {
                                    _sCfmz.show({
                                      pfx: `ログインID「${$idz.id}」のメールアドレスを確認できなかったため、パスワードの送信に失敗しました。`,
                                      ls: [{ key: 1, pfx: 'はい'}],
                                    });                                  
                                  });
                                }
                                return _b2;
                              },
                            ]);
                            if (_b) {
                              const _mailz = ihv.mailz.lz.grtMailSendPwd({
                                i18rz: _i18z?.i18rz,
                              });
                              await icm.setStgzAsync({ // 団体の属する施設の設定で上書き（通常、団体側のログイン画面で施設は特定できないことに留意）
                                _31r_fst: _i18z?.i18rz?.i18r_31r1f,
                              });
                              icm.gasMailAsync({
                                i18r_fst: _i18z?.i18rz?._fst,
                                _31r_fst: _i18z?.i18rz?.i18r_31r1f,
                                ... _mailz
                              });
                              _sLdrz.hide();
                              _sCfmz.show({
                                pfx: '登録されているメールアドレスにパスワードを送信しましたので、ご確認ください。',
                                ls: [{ key: 1, pfx: 'はい'}],
                              });
                            }
                            else {
                              _sLdrz.hide();
                            }

                          }
                        },
                        bfrCz: {
                          textz: {
                            pfx: '※ パスワードが不明な場合、ログインIDを入力した後、',
                            stlz: a('ts/s'),
                          }
                        },
                        linkCz: {
                          textz: {
                            pfx: 'こちら',
                            stlz: a('ts/s tb tc/yw5 tu'),
                          }
                        },
                        atrCz: {
                          textz: {
                            pfx: 'を押してください。',
                            stlz: a('ts/s'),
                          }
                        },
                      }),

                      cr.c(TextC.N, {
                        key: -30,
                        textz: {
                          pfx: '※ ログインIDが不明な場合は、窓口までお問い合わせください。',
                          stlz: a('ts/s'),
                        },
                      }),

                      cr.c(TextC.N, {
                        key: -40,
                        textz: {
                          pfx: '※ 本システムは、最新版の Chrome, Safari, Edge, FireFox にてご利用いただけます。',
                          stlz: a('ts/s'),
                        },
                      }),

                    ]
                  }
                ]
              }
              : null,
              {
                boxStlz: 
                  cr.chkDvc() == 'p' ?
                    a('f/1')
                  : a('f/n'),
                cellCs: [
                ]
              },
            ]
          }),

          cr.c(IccvFtr, {
            key: -30,
          })

        ],
      },
    })
  );
};
